import { OutgoingPostbackStepLogsTable } from "components/Tables/OutgoingPostbackStepLogsTable/OutgoingPostbackStepLogsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/")({
    component: TrackingToLogsPage,
    staticData: {
        permissions: [PermissionEnum.OutgoingPostbackView],
        showInSideMenu: false,
        label: "pages.log.tracking.to-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.to-old.title"),
        };
    },
});

function TrackingToLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <OutgoingPostbackStepLogsTable />
        </TenantPage>
    );
}
